import {t} from "@lingui/core/macro";
import {css, StyleSheet} from "aphrodite";
import * as React from "react";

import {View} from "@khanacademy/wonder-blocks-core";
import {Spring} from "@khanacademy/wonder-blocks-layout";
import {color} from "@khanacademy/wonder-blocks-tokens";
import {
    Body,
    HeadingLarge,
    HeadingSmall,
} from "@khanacademy/wonder-blocks-typography";
import {mediaQueries} from "@khan/shared-styles";
import {staticUrl} from "@khan/urls";

import {PAGE_WIDTH} from "./styles.ts";
import type {Images, Strings} from "./types.ts";

type Props = {
    strings: Strings;
    images: Images;
};

export default class Details extends React.Component<Props> {
    render(): React.ReactNode {
        const {strings, images} = this.props;

        return (
            <View style={styles.detailsWrapper}>
                <Spring />
                <View style={styles.details}>
                    <HeadingLarge>{strings.kaAndIt}</HeadingLarge>
                    <Body style={styles.description}>
                        {strings.kaAndItDescription}
                    </Body>
                    <div>
                        {strings.kaAndItBulletPoints.map((point, i) => (
                            <View key={i} style={styles.bullet}>
                                <View style={styles.bulletInfo}>
                                    <HeadingSmall style={styles.headerSmall}>
                                        {point[0]}
                                    </HeadingSmall>
                                    {point[1].split("\n").map((p, i) => (
                                        <Body style={styles.bulletText} key={i}>
                                            {p}
                                        </Body>
                                    ))}
                                </View>
                                <Spring />
                                <img
                                    alt={t`Screenshot`}
                                    src={staticUrl(
                                        images.kaAndItBulletPoints[i],
                                    )}
                                    className={css(styles.bulletImg)}
                                />
                            </View>
                        ))}
                    </div>
                </View>
                <Spring />
            </View>
        );
    }
}

const styles = StyleSheet.create({
    detailsWrapper: {
        backgroundColor: color.offWhite,
        width: "100%",
        alignItems: "center",
        flexDirection: "row",
    },
    details: {
        flexBasis: PAGE_WIDTH,
        maxWidth: PAGE_WIDTH,
        marginTop: 64,
        marginBottom: 16,
        [mediaQueries.mdOrSmaller]: {
            marginTop: 48,
            marginLeft: 24,
            marginRight: 24,
        },
    },
    description: {
        marginTop: 24,
        maxWidth: 640,
        marginBottom: 48,
    },
    bullet: {
        flexDirection: "row",
        [mediaQueries.smOrSmaller]: {
            flexDirection: "column",
        },
    },
    bulletInfo: {
        maxWidth: 352,
        marginRight: 32,
        [mediaQueries.smOrSmaller]: {
            maxWidth: "100%",
        },
    },
    bulletText: {
        marginTop: 16,
    },
    bulletImg: {
        alignSelf: "center",
        width: 541,
        marginBottom: 48,
        borderRadius: 4,
        boxShadow: "0 3px 6px 0 rgba(33, 36, 44, 0.08)", // custom, from Zeplin
        [mediaQueries.mdOrSmaller]: {
            width: 436,
        },
        [mediaQueries.smOrSmaller]: {
            width: "100%",
            marginTop: 24,
            marginBottom: 40,
        },
    },
    headerSmall: {
        [mediaQueries.mdOrSmaller]: {
            fontSize: 16,
        },
    },
});
